import cx from 'classnames'
import { forwardRef, ForwardRefExoticComponent, RefAttributes } from 'react'

import { Icons } from '../Icon'
import { LinkProps } from '../Link'
import { PictureProps } from '../Picture'
import { RichTextProps } from '../RichText'
import { RoundedTagProps } from '../RoundedTag'

import * as SC from './styled'

export type ArticleCardProps = {
  className?: string
  tags?: RoundedTagProps[]
  pictureProps?: PictureProps
  richTextProps?: RichTextProps
  date?: string
  readingTime?: string
  linkProps?: LinkProps
}

const ArticleCard: ForwardRefExoticComponent<
  ArticleCardProps & RefAttributes<HTMLDivElement>
> = forwardRef<HTMLDivElement, ArticleCardProps>(
  (
    {
      className,
      tags,
      pictureProps,
      richTextProps,
      date,
      readingTime,
      linkProps,
    },
    ref
  ) => {
    return (
      <SC.Container className={cx('ArticleCard', className)} ref={ref}>
        <SC._Link {...linkProps} as={!linkProps?.href ? 'article' : undefined}>
          {pictureProps && <SC._Picture {...pictureProps} />}
          <SC.Content>
            {tags && (
              <SC.Tags>
                {tags.map((tag, index) => (
                  <SC._RoundedTag key={index} {...tag} />
                ))}
              </SC.Tags>
            )}
            <SC._RichText {...richTextProps} />
            {(date || readingTime) && (
              <SC.Metas>
                {date && <SC.Date>{date}</SC.Date>}
                {readingTime && (
                  <SC.ReadingTime>
                    <SC.ReadingIcon icon={Icons.timer} />
                    {readingTime}
                  </SC.ReadingTime>
                )}
              </SC.Metas>
            )}
          </SC.Content>
          <SC._Icon icon={Icons.bigArrowRight} />
        </SC._Link>
      </SC.Container>
    )
  }
)

ArticleCard.displayName = 'ArticleCard'

export default ArticleCard
